import Crud from '../views/Municipio/Crud'
import Entity from '../views/Municipio/Add'

let routes = {
    path: '/municipios',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/municipios/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/municipios/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        {
            path: '/municipios',
            name: 'list-municipios',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Municipios',
                breadcrumb: [
                    {
                        text: 'Municipios',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
